// Simple pub/sub notification bus for app-wide messages
export type Notice = {
  id: string;
  level: 'info' | 'warning' | 'error' | 'success';
  message: string;
  detail?: string;
  ts: number;
};

type Listener = (n: Notice) => void;

const listeners = new Set<Listener>();

export function onNotice(handler: Listener) {
  listeners.add(handler);
  return () => listeners.delete(handler);
}

function emit(n: Notice) {
  for (const l of Array.from(listeners)) {
    try {
      l(n);
    } catch (_) {
      // ignore listener errors
    }
  }
}

let counter = 0;
function makeId() {
  counter = (counter + 1) % 1_000_000;
  return `${Date.now()}-${counter}`;
}

function toText(err: unknown) {
  if (!err) return '';
  if (typeof err === 'string') return err;
  if (err instanceof Error) return err.message;
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
}

export function notify(level: Notice['level'], message: string, detail?: unknown) {
  emit({ id: makeId(), level, message, detail: toText(detail), ts: Date.now() });
}

export const notifyInfo = (m: string, d?: unknown) => notify('info', m, d);
export const notifyWarn = (m: string, d?: unknown) => notify('warning', m, d);
export const notifyError = (m: string, d?: unknown) => notify('error', m, d);
export const notifySuccess = (m: string, d?: unknown) => notify('success', m, d);
